export default {
    "preview": {
        "noDocumentDataErrorPopupTitle": "Fehler beim Laden der Dokumentdaten",
        "highlightsTitle": "Markierungen",
        "noEntityToHighlight": "Keine Markierungen im Dokument verfügbar",
        "termXLabel": "Suchbegriff",
        "otherTerms": "Andere Begriffe",
        "previousDocument": "Vorheriges Dokument",
        "nextDocument": "Nächstes Dokument",
        "originalDocument": "Originales Dokument",
        "selectedHighlight": "Ausgewählte Markierung",
        "noSelectedHighlight": "Keine Markierung ausgewählt",
        "firstHighlightButtonAltText": "Erste Markierung",
        "previousHighlightButtonAltText": "Vorherige Markierung",
        "nextHighlightButtonAltText": "Nächste Markierung",
        "lastHighlightButtonAltText": "Letzte Markierung",
        "highlightFilters": {
            "title": "Filter",
            "keepAll": "Alle",
            "keepNone": "Keine",
            "keepAllInCategory": "Alle",
            "keepNoneInCategory": "Keine"
        },
        "documentPropertiesTitle": "Dokumenteigenschaften",
        "similarDocumentsTitle": "Ähnliche Dokumente",
        "showAll": "Zeige alle Werte",
        "sortAlphabetically": "Alphabetische Sortierung",
        "sortFrequency": "Sortierung nach Häufigkeit",
        "loading": "Laden...",
        "noextract": "kein Auszug",
        "search": "Suche",
        "gotopage": "Zur Seite gehen",
        "page": "Seite {page}",
        "current": "aktuell"
    },
    "facet": {
        "preview": {
            "closeTitle": "Schließen",
            "expandTitle": "Maximieren",
            "minimize": "Rauszoomen",
            "maximize": "hineinzoomen",
            "toggleExtracts": "Schalten Sie die Hervorhebung relevanter Auszüge um",
            "extracts": "Relevante Auszüge",
            "toggleEntities": "Schalten Sie die Hervorhebung von Objekten",
            "entities": "Objekten",
            "passages": "Relevante Passagen",
            "showPassages": "Von Neural Search extrahierte Passagen zeigen/ausblenden",
            "downloadPdf": "PDF-Version herunterladen",
            "viewPreview": "Vorschau",
            "viewPassages": "Passagen",
            "documentPreview": "Dokumentvorschau",
            "documentPreviewTitle": "Dies ist die Dokumentenvorschau",
            "documentPreviewDescription": "Klicken Sie auf eines Ihrer Suchergebnisse, um das Dokument hier in der Vorschau anzuzeigen."
        }
    }
};
